<template>
  <div class="card m-0 custom-card-borders-style-invitation-left">
    <header-invitation :campaign="campaign"></header-invitation>

    <div class="p-15">
      <b-tabs lazy :active-nav-item-class="'active-tab-custom'" nav-wrapper-class="nav-tabs-left-side-invitation">
        <b-tab :title="$t('invitation.detailColaboration')" active>
          <div ref="overview" class="div-description mb-2 mt-3" v-html="campaign.description"></div>
          

          <div v-if="campaign.custom_message" class="mb-2">
            <h4 class="text-left">Mensaje para link de invitación</h4>
            <div class="agreement-html-link-invitation-left-side" v-html="campaign.custom_message"></div>
          </div>

          <div v-if="agreement_with_creator">
            <h4 class="text-left">Acuerdo</h4>
            <div v-html="agreement_with_creator" class="agreement-html-link-invitation-left-side"></div>
          </div>
          
        </b-tab>
        <b-tab
          :title-item-class="{ 'custom-tab-disabled': !owner.valid || campaign.campaign_influencer.status_influencer !== 'approved' }"
          :disabled="!owner.valid || campaign.campaign_influencer.status_influencer !== 'approved'"
        >
          <template #title>
            <span id="lol">{{ $t('invitation.uploadContentsThisCollaboration') }}</span>
            <b-tooltip triggers="hover" target="lol" v-if="!owner.valid || campaign.campaign_influencer.status_influencer !== 'approved'">{{ $t('invitation.necessaryUploadContents') }}</b-tooltip>
          </template>
          <content-invitation :campaign="campaign" class="mt-3"/>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import {    
  BTab,
  BTabs,
  BTooltip,
} from "bootstrap-vue";

export default {
  name: 'leftSide',
  components: {
    BTab,
    BTabs,
    BTooltip,
    headerInvitation: () => import('@/views/components/invitation/headerInvitation.vue'),
    contentInvitation: () => import('@/views/components/invitation/contentInvitation.vue'),
  },
  props: {
    campaign: {
      required: true,
      type: Object,
    },
    owner: {
      required: true,
      type: Object,
    },
  },
  computed: {
    agreement_with_creator() {
      return this.campaign?.campaign_influencer?.agreement_with_creator || '';
    },
  },
};
</script>

<style lang="scss" scoped>
  .div-description {
    font-family: 'avenir-medium';
    font-weight: 400;
    line-height: 1.5;
  }
  .p-15 {
    padding: 1.5rem;
  }
.custom-card-borders-style-invitation-left {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
</style>
<style lang="scss">

.nav-tabs-left-side-invitation {
  .nav-item {
    a {
      border-bottom: 5px solid rgb(235, 235, 235);
    }
  }
  .custom-tab-disabled > a {
    pointer-events: all !important;
  }
  .custom-tab-disabled > a:hover{
    cursor: not-allowed !important;
  }
  :first-child {
    margin-right: 0.5em;
  }
}
.active-tab-custom {
  color: #0096fe !important;
  border-bottom: 5px solid #0096fe !important;
  transform: scaleX(1.05);
  transition: all 300ms;
}
.nav-tabs-left-side-invitation {
  .nav-link:after {
    background: transparent !important;
  }
}

.agreement-html-link-invitation-left-side {
  font-family: 'avenir-medium', sans-serif;
  font-weight: 400;
  line-height: 1.6;
  font-size: 1rem;

  p {
    margin-bottom: 1em;
  }

  strong {
    font-weight: 600;
  }

  em {
    font-style: italic;
  }

  ul, ol {
    padding-left: 1.5rem;
  }
  u {
    text-decoration: underline;
  }
  a {
    color: #0096fe;
    text-decoration: underline;
  }
}
</style>
